export default __webpack_public_path__ + "static/media/lasg.a19ae52e.jpeg";